module.exports = __webpack_public_path__ + "images/img_IP_8-1766629edf.png";